import * as stylex from '@stylexjs/stylex';
import { useQuery } from '@apollo/client/react';
import { useParams } from 'react-router';
import { useOpenApp } from '~components/AppCta';
import { shared } from '~styles';
import { styles } from './styles';
import { PUBLIC_GROUP } from './query';
import { Facts } from './components/Facts';
import { SpotMap } from './components/SpotMap';
import { Capacity } from './components/Capacity';
import { Logistics } from './components/Logistics';
import { Members } from './components/Members';
import { JoinFab, JoinButton } from './components/JoinFab';
import { Stub } from './components/Stub';
export function Group() {
  const {
    linkId = ''
  } = useParams();
  useOpenApp(`triby/${linkId}`);
  const {
    data,
    loading,
    error
  } = useQuery(PUBLIC_GROUP, {
    variables: {
      id: linkId
    }
  });
  if (loading) {
    return <main {...stylex.props(styles.container)}>
        <p {...stylex.props(shared.muted)}>Loading…</p>
      </main>;
  }
  const group = data?.publicGroup;
  if (error || !group) return <Stub linkId={linkId} />;
  return <main {...stylex.props(styles.container)}>
      {group.archivedAt && <div {...stylex.props(styles.col1, styles.banner)}>This tribe has been archived.</div>}

      <h1 {...stylex.props(styles.col1, styles.title)}>{group.title}</h1>

      {group.description && <p {...stylex.props(styles.col1, styles.description)}>{group.description}</p>}

      {group.spot && <div {...stylex.props(styles.col1)}>
          <SpotMap spot={group.spot} />
        </div>}

      <div {...stylex.props(styles.col1)}>
        <Facts group={group} />
      </div>

      <aside {...stylex.props(styles.side)}>
        <Capacity count={group.memberCount} max={group.maxSize} />
        <Logistics scheduledAt={group.scheduledAt} spot={group.spot} />
        <JoinButton linkId={group.linkId} />
      </aside>

      <div {...stylex.props(styles.col1)}>
        <Members members={group.members} count={group.memberCount} />
      </div>

      <JoinFab linkId={group.linkId} />
    </main>;
}